import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { FormArrayItem } from '@app/components/form/array/FormArrayItem';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { fragmentsManageMessages } from '../../fragments-manage-messages';
import { DescriptionFootersFormValues } from '../types';
import { DescriptionFooterItem } from './DescriptionFooterItem';

/** Field array + save actions for the description footers form. */
export function DescriptionFootersFormContent() {
  const { $t } = useIntl();

  return (
    <Stack spacing={3}>
      <ContentCluster message={fragmentsManageMessages.registeredFootersTitle} divider={false}>
        <FormArrayItem<DescriptionFootersFormValues>
          name="descriptionFooters"
          addButtonLabel={$t({
            id: 'admin.fragments.addNewFooter',
            defaultMessage: 'Agregar nuevo footer',
          })}
          defaultItem={{
            name: '',
            content: '',
            default: false,
          }}
          getItemDisplayName={(item) => item?.name || $t(fragmentsManageMessages.newFooterName)}
          renderItem={({ index }) => <DescriptionFooterItem index={index} />}
        />
      </ContentCluster>

      <FormActionsMui
        saveLabel={$t({
          id: 'common.actions.save',
          defaultMessage: 'Guardar',
        })}
      />
    </Stack>
  );
}
